import * as React from 'react';
function checkIsMobile() {
    if (typeof window !== 'undefined') {
        return window.matchMedia('(pointer: coarse)').matches;
    }
    return false;
}
/**
 * An Popover component displaying additional information.
 */
export var Popover = function (_a) {
    var _b = _a.position, position = _b === void 0 ? 'bottom' : _b, popoverTitle = _a.popoverTitle, popoverText = _a.popoverText, children = _a.children;
    var _c = React.useState(false), isPopoverVisible = _c[0], setIsPopoverVisible = _c[1];
    var _d = React.useState(checkIsMobile), isMobile = _d[0], setIsMobile = _d[1];
    var buttonRef = React.useRef(null);
    var popoverRef = React.useRef(null);
    var togglePopover = function () { return isMobile && setIsPopoverVisible(function (prev) { return !prev; }); };
    var showPopover = function () { return !isMobile && setIsPopoverVisible(true); };
    var hidePopover = function () { return !isMobile && setIsPopoverVisible(false); };
    React.useEffect(function () {
        var checkIfMobile = function () { return setIsMobile(checkIsMobile); };
        window.addEventListener('resize', checkIfMobile);
        return function () { return window.removeEventListener('resize', checkIfMobile); };
    }, []);
    React.useEffect(function () {
        if (isMobile && isPopoverVisible) {
            var handleClickOutside_1 = function (event) {
                var pc = popoverRef.current;
                var bc = buttonRef.current;
                if (pc && bc && !pc.contains(event.target) && !bc.contains(event.target)) {
                    setIsPopoverVisible(false);
                }
            };
            document.addEventListener('mousedown', handleClickOutside_1);
            return function () { return document.removeEventListener('mousedown', handleClickOutside_1); };
        }
    }, [isMobile && isPopoverVisible]);
    return (React.createElement("div", { className: "popover-container", onMouseEnter: showPopover, onMouseLeave: hidePopover },
        React.createElement("div", { ref: buttonRef, onClick: togglePopover, className: "popover-trigger-icon" }, children),
        React.createElement("div", { ref: popoverRef, className: "popover-content popover-position-".concat(position, " ").concat(isPopoverVisible ? 'popover-visible' : 'popover-hidden') },
            popoverTitle && React.createElement("strong", null, popoverTitle),
            popoverText)));
};
//# sourceMappingURL=index.js.map